import { all_routes } from "../../../../feature-module/router/all_routes";

export const institutionSidebarData = [
    {
        title:'Dashboard',
        icon:'isax isax-grid-35',
        route: all_routes.institutionDashboard
    },
    {
        title:'Programs',
        icon:'fa-solid fa-magnifying-glass-plus',
        route: all_routes.institutionPrograms
    },
    {
        title:'Applications',
        icon:'fa-solid fa-user',
        route: all_routes.institutionApplications
    },
    {
        title:'Profile',
        icon:'isax isax-teacher5',
        route: all_routes.institutionProfile
    },
]